module.exports = __webpack_public_path__ + "img/VU.0c83fc4f.svg";